import { ALTERAR_REGISTROS_POR_PAGINA_RESERVA_BPE } from '../types'

export default function alterarRegistrosPorPaginaReservaBpe (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_RESERVA_BPE,
    payload: valor
  }
}
